import { getOfflineDb, type OfflinePhoto } from './db.js';

/**
 * Phase 10 — local blob store for queued photo uploads. We keep the
 * raw Blob in IndexedDB and replay it via the existing direct-upload
 * flow once the network returns.
 */

function randomId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export async function savePhoto(args: {
  userId: string;
  orgSlug: string;
  blob: Blob;
  filename: string;
  parentKey: string;
}): Promise<string> {
  const id = randomId();
  const row: OfflinePhoto = {
    id,
    userId: args.userId,
    orgSlug: args.orgSlug,
    blob: args.blob,
    filename: args.filename,
    contentType: args.blob.type || 'application/octet-stream',
    parentKey: args.parentKey,
    uploadId: null,
    createdAt: Date.now(),
  };
  await getOfflineDb().photos.put(row);
  return id;
}

export async function listPhotosForParent(parentKey: string): Promise<OfflinePhoto[]> {
  return getOfflineDb().photos.where('parentKey').equals(parentKey).toArray();
}

export async function getPhoto(id: string): Promise<OfflinePhoto | undefined> {
  return getOfflineDb().photos.get(id);
}

export async function markPhotoUploaded(id: string, uploadId: string): Promise<void> {
  await getOfflineDb().photos.update(id, { uploadId });
}

export async function deletePhoto(id: string): Promise<void> {
  await getOfflineDb().photos.delete(id);
}

export async function deletePhotosForParent(parentKey: string): Promise<void> {
  await getOfflineDb().photos.where('parentKey').equals(parentKey).delete();
}
